export const injectStyles = () => {
  if (document.getElementById("ahp-styles-v10")) return;
  const s = document.createElement("style");
  s.id = "ahp-styles-v10";
  s.textContent = `
    :root {
      --ff:'DM Sans','Segoe UI',sans-serif;
      --fm:'JetBrains Mono','Fira Mono',monospace;
      --bg:#f0f2f7; --card:#fff;
      --bdr:#e4e8f0; --bdr2:#f0f2f7;
      --ink:#0f172a; --ink2:#334155; --ink3:#64748b; --ink4:#94a3b8;
      --blue:#3b82f6; --blue2:#bfdbfe; --blue3:#eff6ff;
      --green:#16a34a; --green2:#dcfce7;
      --amber:#d97706; --amber2:#fef3c7;
      --red:#dc2626; --red2:#fee2e2;
    }
    @keyframes ahpSpin    { to{transform:rotate(360deg);} }
    @keyframes ahpShimmer { 0%{background-position:200% 0}100%{background-position:-200% 0} }
    @keyframes ahpDown    { from{opacity:0;transform:translateY(-5px)}to{opacity:1;transform:none} }
    @keyframes ahpUp      { from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none} }
    @keyframes ahpFade    { from{opacity:0}to{opacity:1} }
    @keyframes ahpSlideUp { from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:none} }
    .ahp-spin    { animation:ahpSpin .7s linear infinite;display:inline-block;border-radius:50%;flex-shrink:0; }
    .ahp-shimmer { background:linear-gradient(90deg,#eef1f7 25%,#e2e6ef 50%,#eef1f7 75%);
                   background-size:200% 100%;animation:ahpShimmer 1.3s infinite;border-radius:6px; }
    .ahp-down    { animation:ahpDown .18s ease both; }
    .ahp-up      { animation:ahpUp .22s ease both; }
    .ahp-fade    { animation:ahpFade .2s ease both; }
    .ahp-slide-up{ animation:ahpSlideUp .25s cubic-bezier(.22,1,.36,1) both; }
    .ahp-row-wrap{ border-bottom:1px solid var(--bdr2);transition:background .12s; }
    .ahp-row     { display:flex;align-items:stretch;cursor:pointer;user-select:none; }
    .ahp-row:hover{ background:#f5f8ff; }
    .ahp-input   { padding:8px 12px;border-radius:8px;border:1.5px solid var(--bdr);
                   font-size:12.5px;font-family:var(--ff);color:var(--ink);background:var(--card);
                   transition:border-color .15s,box-shadow .15s;box-sizing:border-box;width:100%; }
    .ahp-input:focus{ outline:none;border-color:var(--blue);box-shadow:0 0 0 3px #eff6ff; }
    .ahp-input:disabled{ background:#f8fafc;color:var(--ink4);cursor:not-allowed;border-color:var(--bdr2); }
    .ahp-sel     { padding:7px 10px;border-radius:8px;border:1.5px solid var(--bdr);
                   font-size:12px;font-family:var(--ff);color:var(--ink);background:var(--card);
                   cursor:pointer;height:36px;transition:border-color .15s; }
    .ahp-sel:focus{ outline:none;border-color:var(--blue); }
    .ahp-sel:disabled{ background:#f8fafc;color:var(--ink4);cursor:not-allowed; }
    .ahp-btn     { display:inline-flex;align-items:center;gap:6px;padding:0 16px;height:36px;
                   border-radius:8px;font-size:12.5px;font-weight:600;cursor:pointer;border:none;
                   font-family:var(--ff);transition:all .15s;white-space:nowrap; }
    .ahp-btn-p   { background:var(--blue);color:#fff; }
    .ahp-btn-p:hover{ background:#2563eb; }
    .ahp-btn-g   { background:transparent;color:var(--ink3);border:1.5px solid var(--bdr); }
    .ahp-btn-g:hover{ background:var(--bg);color:var(--ink2); }
    .ahp-btn-sm  { height:30px;padding:0 12px;font-size:11.5px; }
    .ahp-btn-amber{ background:#fff7ed;color:var(--amber);border:1.5px solid #fed7aa; }
    .ahp-btn-amber:hover{ background:var(--amber2); }
    .ahp-lbl     { font-size:10px;font-weight:700;color:var(--ink4);text-transform:uppercase;
                   letter-spacing:.07em;font-family:var(--fm);margin-bottom:5px;display:block; }
    .ahp-drop    { border:2px dashed var(--bdr);border-radius:10px;padding:22px 18px;
                   text-align:center;background:var(--bdr2);
                   transition:border-color .15s,background .15s; }
    .ahp-drop.active{ border-color:var(--blue);background:var(--blue3); }
    .ahp-drop.clickable{ cursor:pointer; }
    .ahp-drop.clickable:hover{ border-color:var(--blue);background:var(--blue3); }
    .ahp-prog    { height:3px;background:var(--bdr2);border-radius:2px;overflow:hidden;margin:8px 0 2px; }
    .ahp-prog-f  { height:100%;border-radius:2px;
                   background:linear-gradient(90deg,var(--blue),#60a5fa);transition:width .25s ease; }
    .ahp-overlay { position:fixed;inset:0;background:rgba(15,23,42,.45);z-index:99999;
                   display:flex;align-items:center;justify-content:center;padding:20px;
                   animation:ahpFade .18s ease; }
    .ahp-modal   { background:#fff;border-radius:16px;box-shadow:0 24px 64px rgba(0,0,0,.18);
                   max-width:820px;width:100%;max-height:90vh;display:flex;flex-direction:column;
                   animation:ahpSlideUp .25s cubic-bezier(.22,1,.36,1); }
    .ahp-modal-hd{ padding:20px 24px 16px;border-bottom:1px solid var(--bdr);
                   display:flex;align-items:center;justify-content:space-between;flex-shrink:0; }
    .ahp-modal-bd{ flex:1;overflow-y:auto;padding:20px 24px; }
    .ahp-doc-card{ border:1px solid var(--bdr);border-radius:10px;overflow:hidden; }
    .ahp-doc-hd  { display:flex;align-items:center;justify-content:space-between;
                   padding:10px 14px;background:#f8fafc;border-bottom:1px solid var(--bdr); }
    .ahp-doc-body{ padding:14px; }
    svg { flex-shrink:0 !important; }
    .ahp-modal-bd::-webkit-scrollbar{ width:5px; }
    .ahp-modal-bd::-webkit-scrollbar-track{ background:var(--bdr2); }
    .ahp-modal-bd::-webkit-scrollbar-thumb{ background:var(--bdr);border-radius:3px; }
    .ahp-close-btn:hover{ background:var(--bdr2) !important; }
    .ahp-open-link:hover{ background:var(--blue2) !important; }
  `;
  document.head.appendChild(s);
};
